import { SponsorRequest } from 'EstraSponsor'
import React from 'react'

import { SponsorRequestDeleteModal } from './SponsorRequestDeleteModal'
import { SponsorRequestEvaluateChangesModal } from './SponsorRequestEvaluateChangesModal'
import { SponsorRequestSendModal } from './SponsorRequestSendModal'
import { SponsorRequestSignModal } from './SponsorRequestSignModal'

export type SponsorRequestActions =
  | 'DELETE'
  | 'SEND'
  | 'SIGN'
  | 'EVALUATE_CHANGES'

type Props = {
  action: SponsorRequestActions
  sponsorRequest: SponsorRequest
  onCloseRequest: () => void
}

export const SponsorRequestActionsModals = ({
  action,
  sponsorRequest,
  onCloseRequest,
}: Props): JSX.Element => {
  return action === 'DELETE' ? (
    <SponsorRequestDeleteModal
      sponsorRequestId={sponsorRequest.id}
      onConfirm={onCloseRequest}
      onCancel={onCloseRequest}
    />
  ) : action === 'SEND' ? (
    <SponsorRequestSendModal
      sponsorRequestId={sponsorRequest.id}
      onConfirm={onCloseRequest}
      onCancel={onCloseRequest}
    />
  ) : action === 'SIGN' ? (
    <SponsorRequestSignModal
      sponsorRequestId={sponsorRequest.id}
      sponsorRequestOutcomeDocument={
        sponsorRequest.outcome_document_url as string
      }
      onConfirm={onCloseRequest}
      onCancel={onCloseRequest}
    />
  ) : action === 'EVALUATE_CHANGES' ? (
    <SponsorRequestEvaluateChangesModal
      sponsorRequest={sponsorRequest}
      onConfirm={onCloseRequest}
      onCancel={onCloseRequest}
    />
  ) : (
    <></>
  )
}
